module.exports = __webpack_public_path__ + "static/media/Leads.bd49bda4.jpg";